import React, { useEffect } from "react";

import { Button, Alert, Loader } from "@partials";
import { AlertType, TabType, SEARCH_FORM_ATMS } from "@constants";
import { getLocalization } from "@utilities";
import { usePagination } from "@hooks";

import { ResultsListType } from "../BranchesAndAtmsList/types";

import { ResultsList } from "../BranchesAndAtmsList/components";

const AtmsResultsDetail: React.FC<ResultsListType> = ({
  api,
  query,
  pagination: defaultPagination,
  localization,
  cultureCode,
  baseUrl,
  pageSize,
  pageSizeDetail,
  hasGeolocation, // this means "knows geolocation coordinates, it is used on pages: 'Branches - Detail' and 'ATMs - Detail'
  latitude,
  longitude,
  iconsList,
}) => {
  const {
    hasNextItems,
    isLoadingMore,
    items,
    loadNewItemsOnDetailPage,
    loadMoreItemsOnDetailPage,
    hasError,
    isLoading,
    query: currentQuery,
  } = usePagination({
    api,
    defaultQuery: query,
    formElement: document.querySelector(`.${SEARCH_FORM_ATMS}`),
    formInputName: "query",
    defaultItems: [],
    defaultPagination,
    cultureCode,
    fetchBodyData: { baseUrl },
    hasSearchCoordinates: true,
    pageSize,
    pageSizeDetail,
    hasGeolocation,
    latitude,
    longitude,
  });

  const noResultsFound = items?.length === 0 && currentQuery;

  useEffect(() => {
    loadNewItemsOnDetailPage();
  }, []);

  return (
    <div>
      {hasError && (
        <div className="mb-8">
          <Alert
            type={AlertType.Error}
            text={getLocalization(localization, "Branches_ErrorMessage")}
            textAttributes={{ role: "alert", "aria-live": "assertive" }}
          />
        </div>
      )}
      {noResultsFound && (
        <div className="mb-8">
          <Alert
            type={AlertType.Error}
            text={getLocalization(localization, "Branches_SearchNoResults")}
            textAttributes={{ role: "alert", "aria-live": "assertive" }}
          />
        </div>
      )}
      {isLoading ? (
        <div className="mb-4 flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <ResultsList
          type={TabType.Atms}
          localization={localization}
          items={items}
          iconsList={iconsList}
        />
      )}

      {hasNextItems && (
        <Button
          template="primary"
          title={getLocalization(localization, "LoadMore")}
          type="button"
          isLoading={isLoadingMore}
          onClick={loadMoreItemsOnDetailPage}
          dataTestId="button-load-more-atms-detail"
        />
      )}
    </div>
  );
};

export default AtmsResultsDetail;
